import { render, staticRenderFns } from "./ConverterBanner.vue?vue&type=template&id=2132032c"
import script from "./ConverterBanner.vue?vue&type=script&lang=ts"
export * from "./ConverterBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports